/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const banquetOrderItemSchema = z.object({
	product_id: z.uuid().nullable(),
	name: z.string(),
	amount: z.number(),
	size: z.string().nullable(),
	total_price: z.number().nullable(),
	modifiers: z.array(z.string()),
});
